export default {
	forms: {
		list: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {
					}
				}
			}
		},
		select: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {
					}
				}
			}
		},
		edit: {
			config: {
				fields: {
					id: {
					},
					name: {
					}
				}
			}
		}
	}
}